import { routeCreator } from "../helpers/routing/routeCreator";
import Applications from "../pages/applications/applications";
import NewApplication from "../pages/applications/newApplication";
import ChangePassword from "../pages/changePassword/changePassword";
import Home from "../pages/home/home.jsx";
import Login from "../pages/login/login.jsx";
import NewAccount from "../pages/newAccount/newAccount";
import NotFound from "../pages/notFound/notFound";
import Verification from "../pages/verification/verification";
import UploadPage from "../pages/fileUpload/uploadPage";
import InitialChangePass from "../pages/changePassword/initialChangePassword";





export const ROUTE_PAGE_LOGIN = routeCreator(Login, '/:campaign/', 'login', 'Login',{ exact: true })
export const ROUTE_CHANGE_PASSWORD = routeCreator(ChangePassword, '/:campaign/changePassword', 'changePassword', 'page.changePasssword')
export const ROUTE_NEW_ACCOUNT = routeCreator(NewAccount, '/:campaign/newAccount', 'newAccount', 'page.newAccount')
export const ROUTE_PAGE_HOME = routeCreator(Home, '/:campaign/', 'home', 'page.home', { exact: true })
export const ROUTE_NOT_FOUND = routeCreator(NotFound, '/:campaign/not-found', 'notFound', 'page.notFound', { exact: true })
export const ROUTE_APPLICATIONS = routeCreator(Applications, '/:campaign/applications', 'applications', 'page.applications')
export const ROUTE_NEW_APPLICATION = routeCreator(NewApplication, '/:campaign/newApplication', 'newApplication', 'page.newApplication')
export const ROUTE_VERIFICATION = routeCreator(Verification, '/:campaign/verification', 'verification', 'page.verification')
export const ROUTE_PAGE_UPLOAD = routeCreator(UploadPage, '/:campaign/uploadPage', 'uploadPage', 'page.uploadPage')
export const ROUTE_PAGE_INITIAL = routeCreator(InitialChangePass, '/:campaign/initial', 'initial', 'page.initial')

const router = {
	ROUTE_APPLICATIONS,
	ROUTE_NOT_FOUND,
	ROUTE_NEW_APPLICATION,
	ROUTE_PAGE_HOME,
	ROUTE_PAGE_UPLOAD,
	ROUTE_PAGE_INITIAL
}

export default router;